"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelIndicators = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../../../constants");
const CHANNEL_COLORS = {
    PUBLISHED: constants_1.Color.LIGHT_BLUE,
    POOL: '#FFA800',
    TENDERED: constants_1.Color.PURPLE,
};
const MAX_BULBS = 3;
const BULB_HEIGHT = 9;
const VERTICAL_SPACING = -2.5;
const StyledSvg = styled_1.default.svg `
  display: inline-block;
  vertical-align: middle;
`;
const Bulb = (props) => {
    const color = CHANNEL_COLORS[props.type];
    const totalHeight = BULB_HEIGHT * MAX_BULBS + VERTICAL_SPACING * (MAX_BULBS - 1);
    const actualContentHeight = BULB_HEIGHT * props.totalBulbs + VERTICAL_SPACING * (props.totalBulbs - 1);
    const verticalOffset = (totalHeight - actualContentHeight) / 2;
    // Base position plus centering offset
    const y = props.position * (BULB_HEIGHT + VERTICAL_SPACING) +
        0.699219 +
        (props.totalBulbs < MAX_BULBS ? verticalOffset : 0);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("rect", { x: "0.613281", y: y, width: "9", height: "9", rx: "4.5", fill: props.active ? color : 'white', stroke: "white" }), (0, jsx_runtime_1.jsx)("rect", { x: "1.613281", y: y + 1, width: "7", height: "7", rx: "3.5", stroke: color })] }));
};
const isSomeUsed = (used) => {
    return Object.values(used).some(utils_1.isTruthy);
};
const getAvailable = ({ publishing, pools, tenders, }) => {
    return [
        publishing && 'PUBLISHED',
        pools && 'POOL',
        tenders && 'TENDERED',
    ].filter(utils_1.isTruthy);
};
const enabled = {
    PUBLISHED: 'isPublished',
    POOL: 'isRequested',
    TENDERED: 'isTendered',
};
const ChannelIndicators = (props) => {
    if (!isSomeUsed(props.used)) {
        return null;
    }
    const channels = getAvailable(props.available);
    if (!channels.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(StyledSvg, { width: 11, height: 23, viewBox: "0 0 11 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, children: channels.map((channel, i) => ((0, jsx_runtime_1.jsx)(Bulb, { type: channel, active: !!props.used[enabled[channel]], position: i, totalBulbs: channels.length }, channel))) }));
};
exports.ChannelIndicators = ChannelIndicators;
